<template>
  <div>
    <Header v-if="!$store.getters.isApp" :title="$route.meta.title" :left-hide="!$route.query.isHistory" />
    <ResultBankSteps
      :is-history="$route.query.isHistory"
      :steps="steps"
      :current="current"
      :name="name"
    >
      <ResultBankInfo :transfer-info="bankContent" />
    </ResultBankSteps>
  </div>
</template>

<script>
import ResultBankInfo from '@/components/ResultBankInfo'
import ResultBankSteps from '@/components/ResultBankSteps'
import { tradeDetail } from '@/api/withdraw'
import { TRANSACTION_STATUS } from '@/constants'
import Header from '@/components/Header'

export default {
  name: 'HaveStepsDetail',
  components: {
    ResultBankInfo,
    ResultBankSteps,
    Header
  },
  data () {
    return {
      bankContent: {},
      name: '',
      steps: [],
      current: 2
    }
  },

  created () {
    const { tradeNo, path } = this.$route.query
    this.name = path || ''
    tradeNo && this.fetchData(tradeNo)
  },
  methods: {
    async fetchData (tradeNo) {
      this.bankContent = await tradeDetail({ tradeNo })
      this.selectSteps(this.bankContent)
    },
    selectSteps (data) {
      const { tradeTime, estimatedReleaseTime, finalTime, status, subject, retMessage } = data
      const normalSteps = [
        {
          name: `${subject} ${this.$t('Initiated')}`,
          time: ''
        },
        {
          name: `${this.$t('proccessing')}`,
          time: '',
          text: `${this.$t('processed')}`
        },
        {
          name: `${this.$t('completed')}`,
          time: ''
        }
      ]
      // status判断失败和成功和等待
      // 交易订单状态 0:等待交易 1:银行受理中 2:银行处理中 3:交易成功 4:交易失败 5:超时交易关闭
      if (status === TRANSACTION_STATUS.success) { // 成功和等待
        this.steps = normalSteps

        this.current = 2
      }

      if (status === TRANSACTION_STATUS.pend || status === TRANSACTION_STATUS.pending) {
        this.steps = normalSteps

        this.current = 1.5
      }

      if (status === TRANSACTION_STATUS.fail || status === TRANSACTION_STATUS.timeout) { // 失败
        this.steps = [
          {
            name: `${subject} ${this.$t('Initiated')}`,
            time: ''
          },
          {
            name: `${this.$t('failed')}`,
            time: '',
            text: ''
          }
        ]
      }

      this.steps.forEach((item, index) => {
        if (status === TRANSACTION_STATUS.success || status === TRANSACTION_STATUS.pend) {
          switch (index) {
            case 0:
              item.time = tradeTime
              break
            case 1:
              item.time = estimatedReleaseTime
              break
            case 2:
              item.time = finalTime
              break
          }
        }

        if (status === TRANSACTION_STATUS.fail || status === TRANSACTION_STATUS.timeout) {
          switch (index) {
            case 0:
              item.time = tradeTime
              break
            case 1:
              item.time = finalTime
              item.text = retMessage
              break
          }
        }
      })
    }
  }
}

</script>
